// Toplu izin mutabakat işleri — sayfanın ve iki çekmecenin ortak kullandığı SAF
// yardımcılar. İstek gövdesi backend LeaveReconciliationBulkRequest'in aynasıdır
// (Dtos/LeaveReconciliation/LeaveReconciliationBulkDtos.cs); önizleme ve başlatma
// AYNI gövdeyi alır — ikisi ayrı kurulsaydı İK'nın gördüğü sayılar başlattığı işle
// kayabilirdi.

export const BULK_KIND = { ZIP: 'zip', NOTIFY: 'notify' };
export const BULK_SCOPE = { SELECTED: 'selected', FILTER: 'filter' };

const ACTIVE_STATUSES = ['queued', 'running'];

export const isActiveJob = (job) => !!job && ACTIVE_STATUSES.includes(job.status);

// "Seçili" kapsamda liste süzgeçleri GÖNDERİLMEZ: seçim listeden yapıldı, süzgeç
// sonradan değiştiyse seçili kişi düşmemeli (backend de o kapsamda süzgeci yok sayar).
// "Süzgeç" kapsamında ise süzgeç listeyle AYNI anlamdadır — `all` durumu süzgeç değildir.
export function buildBulkRequest({
  kind, year, scope, selectedIds, status, departmentId, regenerateGenerated, skipAlreadyNotified,
}) {
  const selected = scope === BULK_SCOPE.SELECTED;
  return {
    kind,
    year,
    scope,
    employeeIds: selected ? [...(selectedIds || [])] : [],
    status: !selected && status && status !== 'all' ? status : null,
    departmentId: !selected && departmentId ? departmentId : null,
    regenerateGenerated: !!regenerateGenerated,
    // Yalnız bildirimde anlamlı; varsayılan AÇIK (backend varsayılanıyla aynı).
    skipAlreadyNotified: skipAlreadyNotified !== false,
  };
}

// Sunucunun saniye tahmini → okunur bir süre. Dakikaya YUKARI yuvarlanır: "1 dakika"
// deyip 80 saniye sürmek, "2 dakika" deyip 80 saniyede bitmekten kötü.
export function estimateParts(seconds) {
  if (!seconds || seconds < 60) return { key: 'underMinute' };
  const totalMinutes = Math.ceil(seconds / 60);
  if (totalMinutes < 60) return { key: 'minutes', count: totalMinutes };
  return { key: 'hours', hours: Math.floor(totalMinutes / 60), minutes: totalMinutes % 60 };
}

export function jobProgress(job) {
  if (!job || !job.totalCount) return 0;
  return Math.min(100, Math.round(((job.processedCount || 0) / job.totalCount) * 100));
}

// Yıl bitmeden hazırlanan form o güne kadarki izinleri gösterir ve hazırlandığı anda
// donar — İK'ya başlatmadan önce söylenir.
export const isYearOpen = (year, now = new Date()) => Number(year) >= now.getFullYear();

// Yoklama sırasında bir iş "etkin"den "bitmiş"e geçtiyse — liste satırlarının durumu
// (hazırlandı / bildirim tarihi) değişmiştir, tablo tazelenmeli.
export function finishedSince(previousJobs, nextJobs) {
  const wasActive = new Set((previousJobs || []).filter(isActiveJob).map((j) => j.id));
  return (nextJobs || []).filter((j) => wasActive.has(j.id) && !isActiveJob(j));
}
